import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import ChannelType from "./ChannelType";
import EditChannelType from "./EditChannelType";

 class Index extends Component {
   constructor(props) {
     super(props);
     this.state = {
       routeStatus: 0,
       dataValue: {},
     };
   }

   changeStatus = (type) => {
     this.setState({
       routeStatus: type,
     });
   };

   changeStatusWithStatusValue = (type, dataValue) => {
     this.setState({
       routeStatus: type,
       dataValue,
     });
   };

   render() {
     const { routeStatus, dataValue } = this.state;
     return (
       <div className="wrapper position-relative">
         {routeStatus == 0 && (
           <ChannelType
             changeStatusWithStatusValue={this.changeStatusWithStatusValue}
           />
         )}

         {routeStatus == 2 && (
           <EditChannelType changeRouteStatus={this.changeStatus} item={dataValue} />
         )}
       </div>
     );
   }
 }
export default (withRouter(Index));